import axios from 'axios';

//import { useDispatch, useSelector } from 'react-redux';
//import { useDispatch } from 'react-redux';

import { userService } from '../_services';
import { alertActions } from '../_actions';

export function errorInterceptor() {
	console.log(" --------------------------- errorInterceptor called ----------------------");

	//const dispatch = useDispatch();

	axios.interceptors.response.use(	
		function(response) { return  response; },
		function(error) {
			if (error.message == 'Network Error') {
				console.log("Network Error");
			} else {
				const { response } = error;
				
				if ([302, 403, 404, 500].includes(response.status)) {
					console.log(response.status + " - " + response.message);
					userService.logout();	
				}
			}
			throw error;
		});

 }
